import '@sendbird/uikit-react/dist/index.css';
import { lazy, Suspense, useEffect } from 'react';

import { ChakraBox } from '@equip.health/ui';

import { ErrorBoundary } from 'react-error-boundary';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useHistory, useLocation } from 'react-router-dom';

import Api from './lib/Api';
import { useModeContext, UserMode } from './lib/contexts/ModeContext';
import useLocalStorage from './lib/hooks/useLocalStorage';
import useAppMonitor from './lib/hooks/useAppMonitor';
import Loading from './pages/loading';
import Routes from './routes';
import { Path } from './routes/constants';

const LazyErrorFallback = lazy(() => import('./pages/ErrorFallback'));

const App = () => {
  const { mode } = useModeContext();
  const appMonitor = useAppMonitor();
  const { setValue: setIntent } = useLocalStorage<string>('intent', Path.HOME);

  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const { pathname, search } = location;
    if (pathname !== Path.HOME) {
      setIntent(pathname + search || '');
    }
    Api.init();
  }, []);

  return (
    <ErrorBoundary
      fallbackRender={(props) => (
        <Suspense fallback={<Loading />}>
          <LazyErrorFallback {...props} />
        </Suspense>
      )}
      onError={(error) => appMonitor.captureException(error)}
      onReset={() => history.push(Path.PORTAL)}
    >
      <HelmetProvider>
        <Helmet>
          <title>Equip{mode !== UserMode.UNKNOWN ? ` | ${mode}` : ''}</title>
        </Helmet>
        <ChakraBox height="100vh">
          <Routes />
        </ChakraBox>
      </HelmetProvider>
    </ErrorBoundary>
  );
};

export default App;
